import {
  CONTRACT_PROGRESS_ATTACHMENT_FILE_UPLOAD_FAILURE,
  CONTRACT_PROGRESS_ATTACHMENT_FILE_UPLOAD_REQUEST,
  CONTRACT_PROGRESS_ATTACHMENT_FILE_UPLOAD_SUCCESS,
  CONTRACT_PROGRESS_ATTACHMENT_LOAD_FAILURE,
  CONTRACT_PROGRESS_ATTACHMENT_LOAD_SUCCESS,
  CONTRACT_PROGRESS_ATTACHMENT_PUT_FILE_INFO_FAILURE,
} from '@app/store/actionTypes';
import { ContractProgressAction } from '@app/store/contract-progress/actions';

type ContractProgressIsAttachingState = boolean;

const initialState: ContractProgressIsAttachingState = false;

export default function reducer(
  state: ContractProgressIsAttachingState = initialState,
  action: ContractProgressAction
) {
  switch (action.type) {
    case CONTRACT_PROGRESS_ATTACHMENT_FILE_UPLOAD_REQUEST:
      return true;
    case CONTRACT_PROGRESS_ATTACHMENT_FILE_UPLOAD_FAILURE:
    case CONTRACT_PROGRESS_ATTACHMENT_LOAD_SUCCESS:
    case CONTRACT_PROGRESS_ATTACHMENT_FILE_UPLOAD_SUCCESS:
    case CONTRACT_PROGRESS_ATTACHMENT_LOAD_FAILURE:
    case CONTRACT_PROGRESS_ATTACHMENT_PUT_FILE_INFO_FAILURE:
      return false;
    default:
      return state;
  }
}
